import { LowerRowButton } from "./lower-row-button"
import "./octave.css"
import { UpperRowButton } from "./upper-row-button"

export const Octave = ({ octaveNumber }: { octaveNumber: number }) => {
  return <div className="sk-octave">

    <LowerRowButton note="C" octaveNumber={octaveNumber} japaneseCharacter="ド" />
    <UpperRowButton octaveNumber={octaveNumber} upperRowButtonNumber={1} />
    <LowerRowButton note="D" octaveNumber={octaveNumber} japaneseCharacter="レ" />
    <UpperRowButton  octaveNumber={octaveNumber} upperRowButtonNumber={2} />

    <LowerRowButton note="E" octaveNumber={octaveNumber} japaneseCharacter="ミ" />
    <LowerRowButton note="F" octaveNumber={octaveNumber} japaneseCharacter="ファ" />

    <UpperRowButton octaveNumber={octaveNumber} upperRowButtonNumber={3} />
    <LowerRowButton note="G" octaveNumber={octaveNumber} japaneseCharacter="ソ" />

    <UpperRowButton  octaveNumber={octaveNumber} upperRowButtonNumber={4} />
    <LowerRowButton note="A" octaveNumber={octaveNumber} japaneseCharacter="ラ" />

    <UpperRowButton  octaveNumber={octaveNumber} upperRowButtonNumber={5} />
    <LowerRowButton note="B" octaveNumber={octaveNumber} japaneseCharacter="シ" />

  </div>
}